<section class="page-hero">
    <div class="hero-copy">
        <p class="eyebrow">Commission plans</p>
        <h1>Transparent earning options for every partner type.</h1>
        <p class="lede">Final terms are confirmed during approval, but these example tiers show how the program is
            structured.</p>
    </div>
</section>
<section class="content-section">
    <table class="plans-table">
        <thead>
            <tr>
                <th>Plan</th>
                <th>Commission</th>
                <th>Best for</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Starter</td>
                <td>30% first year</td>
                <td>New ambassadors validating their YachtApp audience.</td>
            </tr>
            <tr>
                <td>Professional</td>
                <td>35% recurring</td>
                <td>Active marine partners with ongoing customer relationships.</td>
            </tr>
            <tr>
                <td>Premium</td>
                <td>Custom</td>
                <td>High-volume channels, strategic partners, and negotiated campaigns.</td>
            </tr>
        </tbody>
    </table>
</section>